const questions = [
    {
        question: "भा्तर",
        choice1: 'भीषण',
        choice2: 'केला',
        choice3: 'भाई',
        choice4: 'होशियार', 
        answer: 3,
    },
    {
        question: "मेधावी",
        choice1: 'प्रकाश',
        choice2: 'प्रतिदिन',
        choice3: 'अपहरण',
        choice4: 'होशियार', 
        answer: 4,
    },
    {
        question: "नित्यम्",
        choice1: 'प्रकाश',
        choice2: 'प्रतिदिन',
        choice3: 'छोड दिया',
        choice4: 'छोटी', 
        answer: 2,
    },
    {
        question: "अत्यजत्",
        choice1: 'छोड दिया',
        choice2: 'छुरी',
        choice3: 'भीषण',
        choice4: 'चाचा', 
        answer: 1,
    },
    {
        question: "कनिष्ठा",
        choice1: 'छुरी',
        choice2: 'छोटी',
        choice3: 'प्रसन्न',
        choice4: 'किनारे', 
        answer: 2,
    },
    {
        question: "पितृव्य:",
        choice1: 'किनारे',
        choice2: 'अपहरण',
        choice3: 'पिता',
        choice4: 'चाचा', 
        answer: 4,
    },
    {
        question: "वयम्",
        choice1: 'क्या',
        choice2: 'अपन',
        choice3: 'हम',
        choice4: 'हम सब', 
        answer: 3,
    },
    {
        question: "दीर्घ",
        choice1: 'दूर तक',
        choice2: 'नामे लिखना',
        choice3: 'हर जगह',
        choice4: 'लंबा', 
        answer: 4,
    },
    {
        question: "पूति",
        choice1: 'छुरी',
        choice2: 'हर जगह',
        choice3: 'साडी गली',
        choice4: 'अपन', 
        answer: 3,
    },
    {
        question: "शुष्क",
        choice1: 'सूखा',
        choice2: 'बच्चा',
        choice3: 'हर जगह',
        choice4: 'आदमी', 
        answer: 1,
    },
    {
        question: "श्लक्ष्ण",
        choice1: 'साल',
        choice2: 'बंटना',
        choice3: 'धुआँ',
        choice4: 'चिकना', 
        answer: 4,
    },
    {
        question: "कुण्ठ",
        choice1: 'कुंठित',
        choice2: 'धरती',
        choice3: 'अपहरण',
        choice4: 'धुंध', 
        answer: 1,
    },
    {
        question: "वृत्त",
        choice1: 'तीखा',
        choice2: 'गोल',
        choice3: 'सीधा',
        choice4: 'जलना', 
        answer: 2,
    },
    {
        question: "तीक्ष्ण",
        choice1: 'भाई',
        choice2: 'हरा',
        choice3: 'तेज़',
        choice4: 'गरदन', 
        answer: 3,
    },
    {
        question: "जीर्ण",
        choice1: 'पुराना',
        choice2: 'जलना',
        choice3: 'साँप',
        choice4: 'धुंध', 
        answer: 1,
    },
    {
        question: "श्वेत",
        choice1: 'पीठ',
        choice2: 'सफेद',
        choice3: 'आदमी',
        choice4: 'प्रकाश', 
        answer: 2,
    },
    {
        question: "मलिन",
        choice1: 'धरती',
        choice2: 'गंदा',
        choice3: 'बंटना',
        choice4: 'धुआँ', 
        answer: 2,
    },
    {
        question: "शीत",
        choice1: 'अपहरण',
        choice2: 'साल',
        choice3: 'ठंड',
        choice4: 'सीधा', 
        answer: 3,
    },
    {
        question: "कृष्ण",
        choice1: 'काली',
        choice2: 'हर जगह',
        choice3: 'तीखा',
        choice4: 'दाहिना', 
        answer: 1,
    },
    {
        question: "हिम",
        choice1: 'छाती',
        choice2: 'बर्फ',
        choice3: 'साँप',
        choice4: 'पीठ', 
        answer: 2,
    },
    {
        question: "पीवस्",
        choice1: 'धुआँ',
        choice2: 'मोटी',
        choice3: 'गरदन',
        choice4: 'भाई', 
        answer: 2,
    },
    {
        question: "चर्मन्",
        choice1: 'पीठ',
        choice2: 'बंटना',
        choice3: 'आदमी',
        choice4: 'त्वचा', 
        answer: 4,
    },
    {
        question: "रज्जु",
        choice1: 'रस्सी',
        choice2: 'धुंध',
        choice3: 'धरती',
        choice4: 'साल', 
        answer: 1,
    },
    {
        question: "शृणोति",
        choice1: 'जलना',
        choice2: 'हर जगह',
        choice3: 'सुनने के लिए',
        choice4: 'तीखा', 
        answer: 3,
    },
    {
        question: "स्मयते",
        choice1: 'हंसना',
        choice2: 'सीधा',
        choice3: 'अपहरण',
        choice4: 'हर जगह', 
        answer: 1,
    },
    {
        question: "वाति",
        choice1: 'हरा',
        choice2: 'पीठ',
        choice3: 'प्रकाश',
        choice4: 'फूंक मारना', 
        answer: 4,
    },
    {
        question: "वमति",
        choice1: 'उबकाई को',
        choice2: 'दाहिना',
        choice3: 'आदमी',
        choice4: 'भाई', 
        answer: 1,
    },
    {
        question: "दशति",
        choice1: 'बंटना',
        choice2: 'धुआँ',
        choice3: 'काटना',
        choice4: 'साल', 
        answer: 3,
    },
    {
        question: "प्लवते",
        choice1: 'गरदन',
        choice2: 'तैरना',
        choice3: 'छाती',
        choice4: 'पीठ', 
        answer: 2,
    },
    {
        question: "आगच्छति",
        choice1: 'जलना',
        choice2: 'तीखा',
        choice3: 'आना',
        choice4: 'धरती', 
        answer: 3,
    },
    {
        question: "घर्षति",
        choice1: 'मलना',
        choice2: 'बाल',
        choice3: 'सीधा',
        choice4: 'धुंध', 
        answer: 1,
    },
    {
        question: "धरति",
        choice1: 'अपहरण',
        choice2: 'हरा',
        choice3: 'रोके रखना',
        choice4: 'पूँछ', 
        answer: 3,
    },
    {
        question: "पांसु",
        choice1: 'अपहरण',
        choice2: 'रेत',
        choice3: 'भाई',
        choice4: 'साल', 
        answer: 2,
    },
    {
        question: "रेणु",
        choice1: 'पीठ',
        choice2: 'आदमी',
        choice3: 'गरदन',
        choice4: 'गर्द', 
        answer: 4,
    },
    {
        question: "मास",
        choice1: 'प्रकाश',
        choice2: 'हर जगह',
        choice3: 'चांद',
        choice4: 'धुआँ', 
        answer: 3,
    },
    {
        question: "लवण",
        choice1: 'तीखा',
        choice2: 'नमक',
        choice3: 'पीठ',
        choice4: 'दाहिना', 
        answer: 2,
    },

    {
        question: "सरस्",
        choice1: 'झील',
        choice2: 'सीधा',
        choice3: 'जलना',
        choice4: 'धरती', 
        answer: 1,
    },
    {
        question: "अश्मन्",
        choice1: 'पूँछ',
        choice2: 'धुंध',
        choice3: 'पथरी',
        choice4: 'बंटना', 
        answer: 3,
    },
    {
        question: "मार्ष्टि",
        choice1: 'साल',
        choice2: 'पोंछना',
        choice3: 'आदमी',
        choice4: 'अपहरण', 
        answer: 2,
    },
    {
        question: "नुदति",
        choice1: 'छाती',
        choice2: 'भाई',
        choice3: 'गरदन',
        choice4: 'धकेलना', 
        answer: 4,
    },
    {
        question: "बध्नाति",
        choice1: 'बांधना',
        choice2: 'पीठ',
        choice3: 'हर जगह',
        choice4: 'बाल', 
        answer: 1,
    },
    {
        question: "गणयति",
        choice1: 'हरा',
        choice2: 'धुआँ',
        choice3: 'गिनना',
        choice4: 'तीखा', 
        answer: 3,
    },
    {
        question: "खनति",
        choice1: 'जलना',
        choice2: 'गड्ढे खोदना',
        choice3: 'धुंध',
        choice4: 'पीठ', 
        answer: 2,
    },
    {
        question: "पतति",
        choice1: 'दाहिना',
        choice2: 'प्रकाश',
        choice3: 'धरती',
        choice4: 'उड़ने के लियें', 
        answer: 4,
    },
    {
        question: "मृद्नाति",
        choice1: 'दबा देना',
        choice2: 'साल',
        choice3: 'बंटना',
        choice4: 'अपहरण', 
        answer: 1,
    },
    {
        question: "वर्तते",
        choice1: 'आदमी',
        choice2: 'भाई',
        choice3: 'अपहरण',
        choice4: 'मुड़ना', 
        answer: 4,
    },
    {
        question: "हन्ति",
        choice1: 'मारने के लिए',
        choice2: 'सीधा',
        choice3: 'हर जगह',
        choice4: 'गरदन', 
        answer: 1,
    },
    {
        question: "म्रियते",
        choice1: 'पूँछ',
        choice2: 'छाती',
        choice3: 'पीठ',
        choice4: 'मरना', 
        answer: 4,
    },
    {
        question: "कृन्तति",
        choice1: 'जलना',
        choice2: 'काटना',
        choice3: 'धुआँ',
        choice4: 'तीखा', 
        answer: 2,
    },
    {
        question: "उदर",
        choice1: 'तोंद',
        choice2: 'धुंध',
        choice3: 'साल',
        choice4: 'प्रकाश', 
        answer: 1,
    },
    {
        question: "शृङ्ग",
        choice1: 'अपहरण',
        choice2: 'दाहिना',
        choice3: 'पीठ',
        choice4: 'सींग', 
        answer: 4,
    },
    {
        question: "तृण",
        choice1: 'घास',
        choice2: 'बंटना',
        choice3: 'आदमी',
        choice4: 'हरा', 
        answer: 1,
    },
    {
        question: "त्वच्",
        choice1: 'भाई',
        choice2: 'छाल',
        choice3: 'हर जगह',
        choice4: 'धरती', 
        answer: 2,
    },
    {
        question: "मूल",
        choice1: 'छाती',
        choice2: 'सीधा',
        choice3: 'गरदन',
        choice4: 'जड़', 
        answer: 4,
    },
    {
        question: "पत्त्र",
        choice1: 'बाल',
        choice2: 'लीफ',
        choice3: 'पूँछ',
        choice4: 'तीखा', 
        answer: 2,
    },
    {
        question: "कृमि",
        choice1: 'धुंध',
        choice2: 'साल',
        choice3: 'प्रकाश',
        choice4: 'कीड़ा', 
        answer: 4,
    },
    {
        question: "यूका",
        choice1: 'पीठ',
        choice2: 'जूं',
        choice3: 'धुआँ',
        choice4: 'जलना', 
        answer: 2,
    },
    {
        question: "मत्स्य",
        choice1: 'मछली',
        choice2: 'दाहिना',
        choice3: 'आदमी',
        choice4: 'पीठ', 
        answer: 1,
    },
    {
        question: "तनु",
        choice1: 'हरा',
        choice2: 'अपहरण',
        choice3: 'पतला',
        choice4: 'बंटना', 
        answer: 3,
    },
    {
        question: "ह्रस्व",
        choice1: 'सीधा',
        choice2: 'भाई',
        choice3: 'धरती',
        choice4: 'कम', 
        answer: 4,
    },
    {
        question: "पञ्चन्",
        choice1: 'छाती',
        choice2: 'गरदन',
        choice3: 'पांच',
        choice4: 'पूँछ', 
        answer: 3,
    },
    {
        question: "कथम्",
        choice1: 'साल',
        choice2: 'प्रकाश',
        choice3: 'कैसे',
        choice4: 'तीखा', 
        answer: 3,
    },
    {
        question: "यकृत्",
        choice1: 'जिगर',
        choice2: 'धुंध',
        choice3: 'हर जगह',
        choice4: 'बाल', 
        answer: 1,
    },
    {
        question: "अनिति",
        choice1: 'जलना',
        choice2: 'धुआँ',
        choice3: 'आदमी',
        choice4: 'साँस लेना', 
        answer: 4,
    },
    {
        question: "वसु",
        choice1: 'हरा',
        choice2: 'पीठ',
        choice3: 'अच्छा',
        choice4: 'दाहिना', 
        answer: 3,
    },
    {
        question: "बध्नाति",
        choice1: 'सीधा',
        choice2: 'अपहरण',
        choice3: 'बांधना',
        choice4: 'बंटना', 
        answer: 3,
    },
    {
        question: "सीव्यति",
        choice1: 'सिलना',
        choice2: 'साँप',
        choice3: 'पूँछ',
        choice4: 'पीठ', 
        answer: 1,
    },
    {
        question: "नक्षत्र",
        choice1: 'छाती',
        choice2: 'साल',
        choice3: 'धरती',
        choice4: 'सितारा', 
        answer: 4,
    },
    {
        question: "अंहु",
        choice1: 'संकीर्ण',
        choice2: 'धुंध',
        choice3: 'भाई',
        choice4: 'तीखा', 
        answer: 1,
    },
    {
        question: "भिनत्ति",
        choice1: 'प्रकाश',
        choice2: 'जलना',
        choice3: 'गरदन',
        choice4: 'विभाजित', 
        answer: 4,
    },
    {
        question: "धरति",
        choice1: 'पकड़',
        choice2: 'धुआँ',
        choice3: 'हरा',
        choice4: 'सीधा', 
        answer: 1,
    },
    {
        question: "हि",
        choice1: 'हर जगह',
        choice2: 'आदमी',
        choice3: 'चूंकि',
        choice4: 'पीठ', 
        answer: 3,
    },
    {
        question: "धूम",
        choice1: 'बंटना',
        choice2: 'धुआं',
        choice3: 'बाल',
        choice4: 'छाती', 
        answer: 2,
    },
    {
        question: "श्वयति",
        choice1: 'प्रफुल्लित',
        choice2: 'दाहिना',
        choice3: 'तीखा',
        choice4: 'साल', 
        answer: 1,
    },
    {
        question: "शीयते",
        choice1: 'पीठ',
        choice2: 'फ्रीज',
        choice3: 'धरती',
        choice4: 'अपहरण', 
        answer: 2,
    },
    {
        question: "दीव्यति",
        choice1: 'बाल',
        choice2: 'खेल',
        choice3: 'धुंध',
        choice4: 'पूँछ', 
        answer: 2,
    },
    {
        question: "सरति",
        choice1: 'जलना',
        choice2: 'बहे',
        choice3: 'प्रकाश',
        choice4: 'भाई', 
        answer: 2,
    },
    {
        question: "गायति",
        choice1: 'धुआँ',
        choice2: 'हरा',
        choice3: 'सीधा',
        choice4: 'गाओ', 
        answer: 4,
    },
    {
        question: "मार्ष्टि",
        choice1: 'पीठ',
        choice2: 'आदमी',
        choice3: 'बंटना',
        choice4: 'पोंछ', 
        answer: 4,
    },
    {
        question: "ददाति",
        choice1: 'देना',
        choice2: 'दाहिना',
        choice3: 'गरदन',
        choice4: 'साल', 
        answer: 1,
    },
    {
        question: "युध्यते",
        choice1: 'हर जगह',
        choice2: 'लड़ाई',
        choice3: 'छाती',
        choice4: 'साँप', 
        answer: 2,
    },
    {
        question: "वमति",
        choice1: 'उलटी करना',
        choice2: 'पीठ',
        choice3: 'धुंध',
        choice4: 'तीखा', 
        answer: 1,
    },
    {
        question: "धयति",
        choice1: 'अपहरण',
        choice2: 'धरती',
        choice3: 'चूसना',
        choice4: 'पूँछ', 
        answer: 3,
    },
    {
        question: "अन्त्र",
        choice1: 'सीधा',
        choice2: 'प्रकाश',
        choice3: 'हिम्मत',
        choice4: 'जलना', 
        answer: 3,
    },
    {
        question: "अक्षि",
        choice1: 'आंख',
        choice2: 'बंटना',
        choice3: 'धुआँ',
        choice4: 'हरा', 
        answer: 1,
    },
    {
        question: "पर्ण",
        choice1: 'भाई',
        choice2: 'पंख',
        choice3: 'साल',
        choice4: 'दाहिना', 
        answer: 2,
    },
    {
        question: "अस्थि",
        choice1: 'बाल',
        choice2: 'पीठ',
        choice3: 'हड्डी',
        choice4: 'गरदन', 
        answer: 3,
    },
    {
        question: "दण्ड",
        choice1: 'साँप',
        choice2: 'छड़ी',
        choice3: 'हड्डी',
        choice4: 'तीखा', 
        answer: 2,
    },
    {
        question: "सर्प",
        choice1: 'सीधा',
        choice2: 'धुंध',
        choice3: 'हड्डी',
        choice4: 'साँप', 
        answer: 4,
    },
    {
        question: "गुरु",
        choice1: 'भारी',
        choice2: 'छाती',
        choice3: 'धरती',
        choice4: 'पीठ', 
        answer: 1,
    },
    {
        question: "तत्",
        choice1: 'पूँछ',
        choice2: 'उस',
        choice3: 'जलना',
        choice4: 'प्रकाश', 
        answer: 2,
    },
    {
        question: "इदम्",
        choice1: 'यह',
        choice2: 'हरा',
        choice3: 'धुआँ',
        choice4: 'आदमी', 
        answer: 1,
    },
    {
        question: "कदा",
        choice1: 'साल',
        choice2: 'बंटना',
        choice3: 'कब',
        choice4: 'दाहिना', 
        answer: 3,
    },
    {
        question: "अत्र",
        choice1: 'बाल',
        choice2: 'यहाँ',
        choice3: 'पीठ',
        choice4: 'हर जगह', 
        answer: 2,
    },
    {
        question: "पितृ",
        choice1: 'सीधा',
        choice2: 'भाई',
        choice3: 'पिता',
        choice4: 'गरदन', 
        answer: 3,
    },
    {
        question: "मातृ",
        choice1: 'मां',
        choice2: 'धुंध',
        choice3: 'तीखा',
        choice4: 'अपहरण', 
        answer: 1,
    },
    {
        question: "भार्या",
        choice1: 'पूँछ',
        choice2: 'पत्नी',
        choice3: 'पीठ',
        choice4: 'हरा', 
        answer: 2,
    },
    {
        question: "अल्प",
        choice1: 'प्रकाश',
        choice2: 'आदमी',
        choice3: 'जलना',
        choice4: 'छोटा', 
        answer: 4,
    },
    {
        question: "भद्र",
        choice1: 'धरती',
        choice2: 'धुआँ',
        choice3: 'अच्छा',
        choice4: 'साल', 
        answer: 3,
    },
    {
        question: "तोज",
        choice1: 'बंटना',
        choice2: 'पानी',
        choice3: 'पीठ',
        choice4: 'दाहिना', 
        answer: 2,
    },
]

export default questions